import {
  request
} from './request'

// 品牌故事 
function pages(data) {
  return request({
    method: 'get',
    url: '/api/v1/index/pages',
    params: data
  })
}

export {
  pages
}



// WEBPACK FOOTER //
// ./src/api/story.js